// extracted by mini-css-extract-plugin
export default {"badges":"AppStoreBadges_badges__beGOv","badge":"AppStoreBadges_badge__K88HF"};